import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import { default as localStyles } from './PageLayout.module.scss';

type PageLayoutProps = {
  className?: string;
  styles?: React.CSSProperties;
};

export const PageLayout = observer<PropsWithChildren & PageLayoutProps>(
  ({ children, className, styles = {} }) => (
    <div className={clsx(localStyles.pageLayout, className)} style={styles}>
      {children}
    </div>
  ),
);
